import { IProductBilling } from 'interfaces/IProduct';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export const useProductBillingService = () => {
  const { callApi } = useFetch();

  interface IProductBillingResponse {
    ProductBillings: IProductBilling[];
  }

  const getAll = useCallback(async () => {
    const result = await callApi<IProductBillingResponse>({
      url: `ProductBilling/GetAll`,
      method: 'get',
      prefixMsgError: 'error in ProductBillingService - getAll:'
    });
    return result;
  }, [callApi]);

  const findOne = useCallback(
    async (productBillingId: number) => {
      const result = await callApi<IProductBilling>({
        url: `ProductBilling/FindProductBillingByProductBillingId/${productBillingId}`,
        method: 'get',
        prefixMsgError: 'error in ProductBillingService - findOne:'
      });
      return result;
    },
    [callApi]
  );

  const add = useCallback(
    async (product: IProductBilling) => {
      await callApi({
        url: 'ProductBilling/Add',
        method: 'post',
        data: product,
        prefixMsgError: 'error in ProductBillingService - add:'
      });
    },
    [callApi]
  );

  const update = useCallback(
    async (productBilling: IProductBilling) => {
      await callApi({
        url: `ProductBilling/Update/${productBilling.Id}`,
        method: 'put',
        data: productBilling,
        prefixMsgError: 'error in ProductBillingService - update:'
      });
    },
    [callApi]
  );

  const destroy = useCallback(
    async (productBillingId: number) => {
      await callApi({
        url: `ProductBilling/Delete/${productBillingId}`,
        method: 'delete',
        prefixMsgError: 'error in ProductBillingService - destroy:'
      });
    },
    [callApi]
  );

  return useMemo(
    () => ({
      productBillingService: {
        getAll,
        findOne,
        add,
        update,
        destroy
      }
    }),
    [getAll, add, findOne, update, destroy]
  );
};
